import { useQuery } from '@tanstack/react-query'
import { getSiteContent } from '../services/content.service'
import { FALLBACK_SITE } from './siteFallback'

/**
 * The dashboard-managed site content. `site` always has the header, footer, logos, product-page values and
 * shipping rules (the built-in originals until the real ones arrive); `loaded` says whether the pages and stores
 * are available too.
 */
export function useSiteContent() {
  const q = useQuery({ queryKey: ['site-content'], queryFn: getSiteContent, staleTime: 60_000, retry: 1 })
  return { ...q, site: { ...FALLBACK_SITE, ...(q.data || {}) }, loaded: !!q.data }
}

// {{phone}}, {{email}}… → the store's details from Site Settings
export const fill = (text, vars) =>
  String(text ?? '').replace(/\{\{\s*([a-z_]+)\s*\}\}/g, (m, key) => (vars && vars[key] !== undefined ? vars[key] : m))
